import { useRef } from "react";
import { Box } from "@mui/material";
import { Typography } from "src/components-mui/base/typography/typography";
import { WfDialog } from "src/components-mui/common/dialog/wf-dialog";
import { useFullscreenOnMobile } from "src/components-mui/modals/video-modal/use-fullscreen-on-mobile";
import { buildEmbedVideoUrl } from "src/components-mui/modals/video-modal/video-modal.helpers";

interface IVideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    videoUrl: string;
}

const VIDEO_MODAL_TITLE_ID = "video-modal-title";

export const VideoModal = ({ isOpen, onClose, title, videoUrl }: Readonly<IVideoModalProps>) => {
    const embedSrc = isOpen ? buildEmbedVideoUrl(videoUrl) : undefined;
    const iframeContainerRef = useRef<HTMLDivElement>(null);

    useFullscreenOnMobile({ elementRef: iframeContainerRef, isActive: isOpen, onExitFullscreen: onClose });

    return (
        <WfDialog isOpen={isOpen} onClose={onClose} ariaLabelledBy={VIDEO_MODAL_TITLE_ID} sx={{ p: 0 }}>
            <Box
                sx={{
                    overflow: "hidden",
                    pl: [3, 5],
                    pt: [8, 5],
                    pr: [3, 8],
                    pb: 3,
                }}
            >
                <Typography
                    id={VIDEO_MODAL_TITLE_ID}
                    component="header"
                    sx={{
                        fontSize: "2xl",
                        fontWeight: "bold",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        display: "-webkit-box",
                    }}
                >
                    {title}
                </Typography>
            </Box>
            <Box
                ref={iframeContainerRef}
                sx={{
                    mb: { xs: 3, sm: 5 },
                    aspectRatio: "16 / 9",
                    backgroundColor: "grey.800",
                    "&:fullscreen": {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                    },
                }}
            >
                {embedSrc && (
                    <Box
                        component="iframe"
                        title={title}
                        src={embedSrc}
                        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                        allowFullScreen
                        sx={{
                            width: "100%",
                            height: "100%",
                            border: 0,
                        }}
                    />
                )}
            </Box>
        </WfDialog>
    );
};
